import { CONSENT_FORM } from './constants';
import fetchWithRefreshV2 from './fetchWithRefreshV2';

type ConsentFormResponse = {
    success: boolean;
    data?: ConsentForm;
    error?: string;
};

export interface ConsentForm {
    docid: string;
    // doctor: DoctorProfile;
    patientid: string;
    // selectedClinicData: ClinicDB;
    content: Contentobject;
    url?: string;
    patientSignRequired: boolean;
    patientSignUrl?: string;
    created_at: string;
}

interface Contentobject {
    heading: string;
    description: string;
}

export default (id: string): Promise<ConsentFormResponse> =>
    fetchWithRefreshV2(CONSENT_FORM(id)).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('failed');
        }
    });
